// src/components/AnswerButtons.js
import React from "react";
import "./style.css";
import { BiLogoInstagram, BiLogoTiktok } from "react-icons/bi";
import { SlSocialYoutube } from "react-icons/sl";
import { Link } from "react-router-dom";

const Footer = ({ handleStartTest }) => {
  function openExternalItem(url) {
    window.open(url, "_blank");
  }

  return (
    <footer>
      <img src="./assets/logo-nevenka.png" alt="Imagem logo footer" />
      <h5>
        Nevenka Garcia © Todos os direitos
        <br /> reservados - <Link to="/privacy-policy">Politica de privacidade</Link>
      </h5>
      <div>
        <BiLogoInstagram
          className="logo-social"
          onClick={() => openExternalItem("https://www.instagram.com/nevenkagarcia/")}
        />
        <SlSocialYoutube
          className="logo-social"
          onClick={() => openExternalItem("https://www.youtube.com/@nevenkagarcia")}
        />
        <BiLogoTiktok
          className="logo-social"
          onClick={() => openExternalItem("https://www.tiktok.com/@nevenkagarcia")}
        />
      </div>
    </footer>
  );
};

export default Footer;
